import { differenceInCalendarDays, getYear, parseISO } from 'date-fns'
import { SeriesNormalized, TimeSeriesComparisonPayload } from '../visualization.types'

export const extractYearFromText = (text?: string | null): number | undefined => {
  if (!text) return undefined
  const y4 = text.match(/\b(20\d{2})\b/)
  if (y4) return Number(y4[1])
  const y2 = text.match(/\b(\d{2})\b/)
  if (y2) return 2000 + Number(y2[1])
  return undefined
}

export const readMeta = (payload: TimeSeriesComparisonPayload) => {
  const refStartISO = payload?.meta?.reference?.start
  const refEndISO = payload?.meta?.reference?.end
  const comparisonStartISO = payload?.meta?.comparison?.start
  const comparisonEndISO = payload?.meta?.comparison?.end

  const refYear = refStartISO ? getYear(parseISO(refStartISO)) : undefined
  const comparisonYear = comparisonStartISO ? getYear(parseISO(comparisonStartISO)) : undefined

  const refDays =
    refStartISO && refEndISO
      ? differenceInCalendarDays(parseISO(refEndISO), parseISO(refStartISO)) + 1
      : undefined

  const comparisonDays =
    comparisonStartISO && comparisonEndISO
      ? differenceInCalendarDays(parseISO(comparisonEndISO), parseISO(comparisonStartISO)) + 1
      : undefined

  const refLabelYear = extractYearFromText(String(payload?.meta?.labels?.reference ?? ''))
  const comparisonLabelYear = extractYearFromText(String(payload?.meta?.labels?.comparison ?? ''))

  return { refYear, comparisonYear, refDays, comparisonDays, refLabelYear, comparisonLabelYear }
}

export const resolveSeriesYear = (
  serie: SeriesNormalized,
  index: number,
  meta: ReturnType<typeof readMeta>,
  fallbackRefYear: number,
): number => {
  if (typeof serie.year === 'number') return serie.year

  const inText = extractYearFromText(serie.labelRaw) ?? extractYearFromText(serie.name)
  if (inText) return inText

  if (meta.refYear && String(serie.name ?? serie.label ?? '').includes(String(meta.refYear))) {
    return meta.refYear
  }
  if (
    meta.comparisonYear &&
    String(serie.name ?? serie.label ?? '').includes(String(meta.comparisonYear))
  ) {
    return meta.comparisonYear
  }
  if (
    meta.refLabelYear &&
    String(serie.name ?? serie.label ?? '').includes(String(meta.refLabelYear))
  ) {
    return meta.refLabelYear
  }
  if (
    meta.comparisonLabelYear &&
    String(serie.name ?? serie.label ?? '').includes(String(meta.comparisonLabelYear))
  ) {
    return meta.comparisonLabelYear
  }

  return (meta.refYear ?? fallbackRefYear) - index
}
